"use strict";

require("core-js/modules/es.array.from");

var curry = require("./curry.js");

var go = require("./go.js");

var juxt = require("./juxt.js");

var sum = require("./sum.js");

var sel = require("./sel.js");

var apply = require("./apply.js");

var divide = require("./divide.js");

var mapL = require("../Lazy/mapL.js");

module.exports = curry(function meanBy(f, iter) {
  return go(iter, mapL(f), Array.from.bind(Array), juxt(sum, sel('length')), apply(divide));
});